import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';
import { RootStore, withInjectedRootStore } from 'providers';
import s from './SaleBanner.scss';
import { SaleBannerSubtitle } from './SaleBannerSubtitle';

const DASH_NOTE = '—';

interface SaleBannerContentProps {
  rootStore: RootStore;
}

const SaleBannerContentComp: React.FunctionComponent<
  SaleBannerContentProps
> = ({ rootStore }) => {
  const { discountPercent } = rootStore.appStore.appContext.saleParams;

  return (
    <Text size='small'>
      {
        <>
          <SaleBannerSubtitle />
          <span className={s.saleDash}>{' ' + DASH_NOTE + ' '}</span>
          <Trans
            i18nKey={'studio_sale.banner.on.select.plans.text'}
            values={{ percent: discountPercent || '50' }}
          >
            <Text weight='bold' className={s.saleDiscountColor}>{discountPercent || '50'}</Text>
            rest
          </Trans>
        </>
      }
    </Text>
  );
};

export const SaleBannerContent = withInjectedRootStore(SaleBannerContentComp);
